import React, { useState, useEffect } from "react";
const ES5PA1Update = ({ ...props }) => {
    const [load, setload] = useState(true)
    const [ErrorCol, setErrorCol] = useState(false)
    const [formData, setFormData] = useState({
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        EmploymentId: Number(props.employmentId),

         Blind3 : 0,
         DeafAndDumb4 : 0,
         Orthopaedics5 : 0,
         RespiratoryDisorder6 : 0,
         NegativeLaprosyPerson7 : 0,
         TotalCol3ToCol78 : 0,
         WomenIncludedInTotal9 : 0,
    });


    const getdata = async () => {
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            ParametersId: Number(props.parametersId),
            EmploymentId: Number(props.employmentId),
        }


        await fetch(process.env.REACT_APP_API_LINK+'api/Main/GetES5PA1Details', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    const maindata = data[0]
                  
                    setFormData({
                        Blind3: maindata.blind3,
                        DeafAndDumb4: maindata.deafAndDumb4,
                        Orthopaedics5: maindata.orthopaedics5,
                        RespiratoryDisorder6: maindata.respiratoryDisorder6,
                        NegativeLaprosyPerson7: maindata.negativeLaprosyPerson7,
                        TotalCol3ToCol78: maindata.totalCol3ToCol78,
                        WomenIncludedInTotal9: maindata.womenIncludedInTotal9,
                        UserId: Number(localStorage.getItem("userId")),
                        ParametersId: Number(props.parametersId),
                        EmploymentId: Number(props.employmentId),
                    });
                    setload(false)
                })


    };
    const onInputChange = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }
   

        await fetch(process.env.REACT_APP_API_LINK + 'api/Calculation/UpdateDetailsES5PA1total1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    
                    
                    setFormData({
                        Blind3: maindata.blind3,
                        DeafAndDumb4: maindata.deafAndDumb4,
                        Orthopaedics5: maindata.orthopaedics5,
                        RespiratoryDisorder6: maindata.respiratoryDisorder6,
                        NegativeLaprosyPerson7: maindata.negativeLaprosyPerson7,
                        TotalCol3ToCol78: maindata.totalCol3ToCol78,
                        WomenIncludedInTotal9: maindata.womenIncludedInTotal9,
                        UserId: Number(localStorage.getItem("userId")),
                        ParametersId: Number(props.parametersId),
                        EmploymentId: Number(props.employmentId),
                    });
                    setload(false)
                    props.setGTotal(!props.GTotal)
                    
                })
        
    };


    const onInputChange1 = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Calculation/UpdateDetailsES5PA1total1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    if (maindata === "Error") {

                        



                    } else {


                        setFormData({
                            Blind3: maindata.blind3,
                            DeafAndDumb4: maindata.deafAndDumb4,
                            Orthopaedics5: maindata.orthopaedics5,
                            RespiratoryDisorder6: maindata.respiratoryDisorder6,
                            NegativeLaprosyPerson7: maindata.negativeLaprosyPerson7,
                            TotalCol3ToCol78: maindata.totalCol3ToCol78,
                            WomenIncludedInTotal9: maindata.womenIncludedInTotal9,
                            UserId: Number(localStorage.getItem("userId")),
                            ParametersId: Number(props.parametersId),
                            EmploymentId: Number(props.employmentId),

                        });
                    }
                    setload(false)
                })
        props.setGTotal(props.GTotal + 1)
    };

    




    useEffect(() => {
        getdata()

    }, [props.Change])


    const inputHandler = (e) => {
        const { value, maxLength } = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };

    return (
        load ? null:
        <tr scope="row"  >

            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                {props.sno} 

            </td>

            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                  {props.name}
            </td>
         
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Blind3"
                        className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Blind3"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Blind3}
                    /> : formData.Blind3}

            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="DeafAndDumb4"
                        className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="DeafAndDumb4"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.DeafAndDumb4}
                    /> : formData.DeafAndDumb4}


            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Orthopaedics5"
                        className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="Orthopaedics5"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Orthopaedics5}
                    /> : formData.Orthopaedics5}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="RespiratoryDisorder6"
                        className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="RespiratoryDisorder6"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.RespiratoryDisorder6}
                    /> : formData.RespiratoryDisorder6}

            </td>
           
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="NegativeLaprosyPerson7"
                        className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="NegativeLaprosyPerson7"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.NegativeLaprosyPerson7}
                    /> : formData.NegativeLaprosyPerson7}

                </td>            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    {formData.TotalCol3ToCol78 < formData.WomenIncludedInTotal9 ? <label style={{ color: 'red' }}>{formData.TotalCol3ToCol78} </label> : <label>{formData.TotalCol3ToCol78} </label>} 
                </td>    
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="WomenIncludedInTotal9"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="WomenIncludedInTotal9"
                        style={formData.TotalCol3ToCol78 < formData.WomenIncludedInTotal9 ? { textAlign: 'center', minWidth: 70, color: 'red' } : { textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.WomenIncludedInTotal9}
                    /> : formData.WomenIncludedInTotal9}

            </td>

        </tr>
    );
};

export default ES5PA1Update;
